<div class="welcome-container">
  <section>
    <app-loading *ngIf="isLoading" />
    <img src="assets/images/svg/logo.svg" alt="Logo" width="229" height="50" />
    <h1 class="title">
      {{ 'Welcome to Eyelation' | translate }}
    </h1>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="welcome-form">
      <div class="w-full">
        <div class="description">
          {{ 'Please enter your username or email.' | translate }}
        </div>
        <mat-form-field class="mat-form-field" appearance="outline">
          <mat-label>{{ 'Username or Email' | translate: { param: '*' } }}</mat-label>
          <input
            id="usernameOrEmail"
            formControlName="usernameOrEmail"
            matInput
            required
            placeholder="{{ 'Username or Email' | translate: { param: '' } }}"
          />
        </mat-form-field>
      </div>
      <app-button [label]="'button.Next' | translate" type="submit" />
    </form>
  </section>
</div>
